module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<header></header> <div class=\"card card-body filter-card\"> <div id=\"daterange_pickers\" class=\"mr-4\"></div> <div id=\"carrier_selector\" class=\"mr-4\"></div> <div id=\"transit_delay_amount_selector\" class=\"mr-4\"></div> <div id=\"delivery_delay_amount_selector\" class=\"mr-4\"></div> <div id=\"tracker_status_selector\"></div> </div> <div id=\"delayed_trackers_list\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/delayed_trackers/template.ejs
// module id = 1641
// module chunks = 1